module.exports = __webpack_public_path__ + "img/fla.29ef85e7.png";